import { AsyncPipe } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Group, GroupType } from '../../../models/group.model';
import {
  MembershipStatus,
  MemberType,
} from '../../../models/membership.status';
import { InitialsPipe } from '../../../pipes/initials.pipe';
import { UtilsService } from '../../../services/utils.service';
import { AppState } from '../../../state/appstate';
import * as groupSelector from '../../../state/selectors/group.selector';
import { BtnActionComponent } from '../../components/buttons/btn-action/btn-action.component';
import { BtnBackComponent } from '../../components/buttons/btn-back/btn-back.component';
import { BtnFabComponent } from '../../components/buttons/btn-fab/btn-fab.component';
import { BtnMemberStatusComponent } from '../../components/buttons/btn-member-status/btn-member-status.component';
import { BtnRouteComponent } from '../../components/buttons/btn-route/btn-route.component';
import { DlgViewProfileComponent } from '../../profile/dlg-view-profile/dlg-view-profile.component';
import { DlgViewLocationComponent } from '../../components/maps/dlg-view-location/dlg-view-location.component';
import { take } from 'rxjs';

@Component({
  selector: 'app-school-settings',
  standalone: true,
  imports: [
    RouterLink,
    AsyncPipe,
    BtnRouteComponent,
    BtnActionComponent,
    BtnFabComponent,
    BtnBackComponent,
    BtnMemberStatusComponent,
    BtnActionComponent,
    InitialsPipe,
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css',
})
export class SchoolSettingsComponent {
  private dialog: MatDialog = inject(MatDialog);

  dropdownPopoverShow = false;

  route: ActivatedRoute = inject(ActivatedRoute);

  group$: Observable<Group | null | undefined> = new Observable();

  groupId: string | null = this.route.snapshot.paramMap.get('id');

  membershipStatus = MembershipStatus;
  memberType = MemberType;
  groupType = GroupType;
  utilsService = UtilsService;
  myRoles$: Observable<any> = new Observable();

  constructor(private store: Store<AppState>) {
    this.group$ = this.store.select(groupSelector.getSelectedGroup);
    this.myRoles$ = this.store.select(
      groupSelector.getMyRolesInGroup(this.groupId),
    );
  }

  toggleDropdown(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.dropdownPopoverShow = !this.dropdownPopoverShow;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    this.dropdownPopoverShow = false;
  }

  onViewProfile() {
    this.dialog.open(DlgViewProfileComponent);
  }

  openMap() {
    this.group$.pipe(take(1)).subscribe((group) => {
      if (group) {
        this.dialog.open(DlgViewLocationComponent, {
          data: {
            location: group.location
          }
        });
      }
    });
  }

  // onNewAcademicYear() {
  //   let data: any = [];
  //   let dialogConfig = new MatDialogConfig();

  //   dialogConfig.data = {
  //     title: 'New Academic Year',
  //     description: 'Initiate a new academic year',
  //     options: data,
  //     // actions: [
  //     //   { label: 'Generate New Academic Year', callback: this.action1.bind(this) },
  //     //   { label: 'Only Archive', callback: this.action2.bind(this) },
  //     //   { label: 'Action 3', callback: this.action3.bind(this) },
  //     // ],
  //   };
  // const dialogRef = this.dialog.open(DlgSelectOptionComponent, dialogConfig);

  // return dialogRef.afterClosed().subscribe((result) => {
  //   if (result !== undefined && this.event) {
  //     return this.store.dispatch(
  //       eventActions.updateStatus({
  //         id: this.event?.id!,
  //         event: {
  //           requestedBy: this.event.requestedBy,
  //           requestedById: this.event.requestedById,
  //           status: result,
  //         } as Event,
  //       })
  //     );
  //   }
  //   return;
  // });
  // }
}
